import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UtilitySharedService } from '../../../services/shared/utility-shared.service';
import { SectionDefinitionService } from '../../../services/section-definition.service';
import { ToastrService } from 'ngx-toastr';
import { SectionDefinition, SectionDefinitionEntityType } from '../../../models/section-definition.model';

@Component({
  selector: 'lib-dedicated-supply-requests',
  templateUrl: './dedicated-supply-requests.component.html',
  styleUrl: './dedicated-supply-requests.component.scss',
  standalone: false
})
export class DedicatedSupplyRequestsComponent implements OnInit {

  constructor(private utilitySharedService: UtilitySharedService,
              private sectionDefinitionService: SectionDefinitionService, 
              private toastr: ToastrService, 
              private cdr: ChangeDetectorRef ) {}

  selectedClass: number = 0;
  sectionDefinitions: SectionDefinition[] = [];
  utilityId!: number | null;
  addNewFieldOpened: boolean = false;
  expandedSectionId: number = -1;

  classes = [
    {
      index: 0,
      label: 'SERVICE_REQUEST.LV_POLE_EXTENSION',
      entitytype: SectionDefinitionEntityType.LVPoleExtension,
    },
    {
      index: 1,
      label: 'SERVICE_REQUEST.MV_POLE_EXTENSION',
      entitytype: SectionDefinitionEntityType.MVPoleExtension,
    }
  ];

  ngOnInit(): void {
    this.selectClass(0);
  }

  selectClass(index: number) {
    this.selectedClass = index;
    this.getSectionDefinitionsForClass(this.classes[index].entitytype);
  }


  getSectionDefinitionsForClass(entityType: number) {
    this.utilityId = this.utilitySharedService.getUtilityId();
    this.sectionDefinitionService.getAllSectionDefinitionsForDmc(entityType, this.utilityId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sectionDefinitions = responseData?.data?.length
            ? responseData?.data?.map((el: any) => new SectionDefinition(el))
            : [];

          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }

  sectionSaved(data: any) {
    this.selectClass(
      this.classes.find((x) => x.entitytype == data.type)?.index!
    );
    this.expandedSectionId = data.id;
  }

  sectionDeleted(id: any) {
    this.sectionDefinitions = this.sectionDefinitions.filter(x => x.id != id);
    this.cdr.detectChanges();
  }

  onSectionUpdated(data: any) {
    this.selectClass(
      this.classes.find((x) => x.entitytype == data.type)?.index!
    );
  }
}
